import { render, staticRenderFns } from "./facedialog.vue?vue&type=template&id=3703b8a1&scoped=true"
import script from "./facedialog.vue?vue&type=script&lang=js"
export * from "./facedialog.vue?vue&type=script&lang=js"
import style0 from "./facedialog.vue?vue&type=style&index=0&id=3703b8a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703b8a1",
  null
  
)

export default component.exports